import { render } from "./App.vue?vue&type=template&id=b194f154"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b194f154&lang=less"

import exportComponent from "/Users/lock/Documents/My Project/lng_xy_fwz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__